/*
 *  scss
 */
require('../scss/index.scss');

/*
 *  core
 */
require("./core/variables.js");
require("./core/events.js");
require("./core/functions.js");

/*
 *  shared partials
 */
require("./shared-partials/form.js");
require("./shared-partials/search.js");

/*
 *  partials
 */
require("./partials/navigation.js");
require("./partials/mobile-navigation.js");
require("./partials/hero.js");
require("./partials/toggle-section.js");
require("./partials/search-popup.js");
require("./partials/contact-popup.js");